// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bt9b_","placeholdersHeader":"styles_placeholdersHeader__36OE4","editorStyle":"styles_editorStyle__mpwc2","placeholdersBox":"styles_placeholdersBox__1OSiy"};